import { IUserTeamCategories } from '../interfaces/user-team-categories.interface';
import { UserTeamCategory } from './user-team-category.enum';

// @dynamic
export class UserTeamCategories {
    static all: IUserTeamCategories[] = [
        {
            name: UserTeamCategory.SUPERVISED,
            translationLabel: 'TEAMS.CATEGORIES.SUPERVISED',
        },
        {
            name: UserTeamCategory.WATCHED,
            translationLabel: 'TEAMS.CATEGORIES.WATCHED',
        },
        {
            name: UserTeamCategory.MEMBERSHIP,
            translationLabel: 'TEAMS.CATEGORIES.MEMBERSHIP',
        },
    ];
}
